import { connect, useDispatch } from "react-redux";
import { getEstadoPedidoByFilter } from "../../../actions/cuentacorriente";
import { useEffect, useState } from "react";
import { ESTADO_PEDIDOS_COLUMN } from "./interface/columnData";
import cuentaCorrienteService from "../../../services/cuentacorriente";
import Filter from "./filter";
import TrackingPedido from "./tracking_pedido";
import TableCustom from "../../../common/components/table/table";
import IFilterEstadoPedido from "./interface/IFilterEstadoPedido";
import IClienteIdFilter from "../../../common/interface/IClienteIdFilter";
import Descarga from "../descarga";
import { useHistory } from "react-router-dom";
import { Button } from "@mui/material";
import { ROL_ENUM } from "../../../enums/rolEnum";
import ISortField from "../../../common/interface/ISortField";

const EstadoPedidos = (props: any) => {
  const dispatch = useDispatch();
  const localStorage = JSON.parse(
    window.localStorage.getItem("LocalSession") || "{}",
  );
  const isAdmin = localStorage.tipoRol === ROL_ENUM.ADMIN;
  const [loading, setLoading] = useState<boolean>(false);
  const [clienteFilter, setClienteFilter] = useState<IClienteIdFilter>({
    clienteId: localStorage.clienteId?.trim(),
    isAdmin: isAdmin,
  });
  const history = useHistory();
  const [filter, setFilter] = useState<IFilterEstadoPedido>({
    dateFrom: null,
    dateTo: null,
    estadoId: null,
    pedidoId: null,
    clienteId: localStorage.clienteId?.trim(),
    page: 0,
    rowPerPage: 5,
    isAdmin: isAdmin,
    sortField: { field: "fecha", order: "DESC" },
  });
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [popUp, setPopUp] = useState(false);
  const [pedidoId, setPedidoId] = useState<string>("");

  const getEstadoPedido = (page: number, rowsPerPage: number): void => {
    filter.rowPerPage = rowsPerPage;
    filter.page = page;
    dispatch(getEstadoPedidoByFilter(filter));
  };
  const getFilterEstadoPedido = (): void => {
    setPage(0);
    setRowsPerPage(5);
    filter.rowPerPage = 5;
    filter.page = 0;
    dispatch(getEstadoPedidoByFilter(filter));
  };

  useEffect(() => {
    dispatch(getEstadoPedidoByFilter(filter));
  }, []);

  // useEffect(() => {
  //     console.log(props.estadopedidos)
  //     // if (props.estadopedidos.data) {
  //     //     setAcopios(props.acopios?.data.$values);
  //     // }
  // }, [props]);

  const handleDownload = async () => {
    setLoading(true);
    const filterExcel = clienteFilter;
    filterExcel.pedidoId = filter.pedidoId;
    filterExcel.dateFrom = filter.dateFrom;
    filterExcel.dateTo = filter.dateTo;
    filterExcel.estadoId = filter.estadoId;

    const response = await cuentaCorrienteService.downloadFileEstadoPedidos(
      filterExcel,
    );
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "status_pedidos.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    setLoading(false);
  };

  const handleNuevoReclamo = async (item: any) => {
    history.push(`/nuevo-reclamo/${item.facturaId}`);
  };

  const handleVerTracking = async (item: any) => {
    setPedidoId(item.pedidoId);
    setPopUp(!popUp);
  };

  const handleClose = () => {
    setPopUp(!popUp);
  };

  const handleSort = (dataKey: string) => {
    const newOrder =
      filter.sortField.field === dataKey && filter.sortField.order === "ASC"
        ? "DESC"
        : "ASC";

    setPage(0);
    const newFilter: IFilterEstadoPedido = {
      ...filter,
      sortField: { field: dataKey, order: newOrder },
      page: 0,
      rowPerPage: 5,
    };
    setFilter(newFilter);
    dispatch(getEstadoPedidoByFilter(newFilter));
  };

  return (
    <div style={{ margin: "2vw" }}>
      {popUp && (
        <TrackingPedido
          handleClose={handleClose}
          pedidoId={pedidoId}
        ></TrackingPedido>
      )}
      <div className="row">
        <div className="col-10">
          <Filter
            getFilterEstadoPedido={getFilterEstadoPedido}
            filter={filter}
            onSelectedFilter={setFilter}
            isAdmin={isAdmin}
            clienteId={localStorage.clienteId?.trim()}
          />
        </div>
        <div className="col-2">
          <Descarga
            loading={loading}
            handleDownload={handleDownload}
          ></Descarga>
        </div>
      </div>

      <TableCustom
        page={page}
        onSelectedPage={setPage}
        rowsPerPage={rowsPerPage}
        onSelectedRowPerPage={setRowsPerPage}
        items={props.estadopedidos?.estadoPedidosResponses}
        length={props.estadopedidos?.length}
        getItems={getEstadoPedido}
        handleNuevoReclamo={handleNuevoReclamo}
        handleVerTracking={handleVerTracking}
        columns={ESTADO_PEDIDOS_COLUMN(isAdmin)}
        onSort={handleSort}
        sortFields={filter.sortField}
      />
    </div>
  );
};
export default connect(
  (state: any) => ({
    estadopedidos: state.cuentacorriente.estadopedidos,
    error: state.cuentacorriente.error,
    loading: state.cuentacorriente.loading,
  }),
  (dispatch) => ({
    getEstadoPedidoByFilter: (filter: IFilterEstadoPedido) =>
      dispatch(getEstadoPedidoByFilter(filter)),
  }),
)(EstadoPedidos);
